import CommandStack from './CommandStack.js';

/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  commandStack: [ 'type', CommandStack ]
};
